import { Widget } from '../Widget';
import { $ } from '../../../vendor/jquery';
import { WidgetType } from '../types';
import {
    GraphicWidgetConfigurationDetails,
    GraphicWidgetConfiguration,
    ZodGraphicWidgetConfigurationDetails,
} from './types';

export class GraphicWidget extends Widget {
    type: WidgetType.GRAPHIC = WidgetType.GRAPHIC;
    declare config: GraphicWidgetConfigurationDetails;

    constructor(widgetConfiguration: GraphicWidgetConfiguration, zoneId: number) {
        super(widgetConfiguration, zoneId);
    }

    async initialize(): Promise<void> {
        await super.initialize();
        this.hasContentToPlay = Widget.valueNotEmpty(this.config.link);
    }

    protected validateConfigurationDetails(
        maybeGraphicWidgetConfigurationDetails: GraphicWidgetConfigurationDetails
    ): GraphicWidgetConfigurationDetails {
        return ZodGraphicWidgetConfigurationDetails.parse(maybeGraphicWidgetConfigurationDetails);
    }

    async getReadyForDisplay(): Promise<void> {
        const id = `img_${this.id}`;
        $(this.wrapperElement).append(
            `<img id='${id}' data-src='${this.config.link}' width='100%' height='100%' style='display:none;' />`
        );
    }
}
